import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { Button } from '@nps.today/component-library';
import { useTranslator } from 'translation/useTranslator';

type UnsavedChangesModalProps = {
  isOpen: boolean;
  onCancel: any;
  onDisregard: any;
  onSave: any;
};

const UnsavedChangesModal = ({
  isOpen,
  onCancel,
  onDisregard,
  onSave
}: UnsavedChangesModalProps) => {
  const translator = useTranslator();
  return (
    <Dialog open={isOpen} onClose={onCancel}>
      <DialogTitle>{translator.unsavedChanges()}</DialogTitle>
      <DialogContent>
        <Typography>{translator.youHaveMadeUnsavedChanges()}</Typography>
        <Typography>{translator.douYouWantToSaveOrDisregardThem()}</Typography>
      </DialogContent>
      <DialogActions>
        <Button dataTestId="unsaved-changes-modal-cancel" color="primary" onClick={onCancel}>
          {translator.cancel()}
        </Button>
        <Button dataTestId="unsaved-changes-modal-save" variant="contained" onClick={onSave}>
          {translator.save()}
        </Button>
        <Button
          dataTestId="unsaved-changes-modal-disregard"
          variant="outlined"
          onClick={onDisregard}
        >
          {translator.disregard()}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnsavedChangesModal;
